module.exports = "<div class=\"usc-store\">\n  <div class=\"row no-gutters usc_table_bar\">&nbsp;</div>\n  <br/>\n  <div [class]=\"loading_class\">Loading Campaign Management...</div>\n  <iframe id=\"ifHome\" [src]=\"url\" width=\"100%\" style=\"border: 0px;\" (load)=\"onload($event)\" [class]=\"display_class\"></iframe>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-manage-campaign/usc-manage-campaign.component.html
// module id = ../../../../../src/app/components/usc-store/usc-manage-campaign/usc-manage-campaign.component.html
// module chunks = main